// GENERATED by scripts/generate-audio-assets.ts from src/assets/sounds/. Do not edit.

import audio0m4a from "../../assets/sounds/S1_OMO_3_1_domine_r1.m4a";
import audio0webm from "../../assets/sounds/S1_OMO_3_1_domine_r1.webm";
import audio1m4a from "../../assets/sounds/S1_OMO_3_1_limite_r1.m4a";
import audio1webm from "../../assets/sounds/S1_OMO_3_1_limite_r1.webm";
import audio2m4a from "../../assets/sounds/S1_OMO_3_1_mascara_r1.m4a";
import audio2webm from "../../assets/sounds/S1_OMO_3_1_mascara_r1.webm";
import audio3m4a from "../../assets/sounds/S1_OMO_3_1_palpito_r1.m4a";
import audio3webm from "../../assets/sounds/S1_OMO_3_1_palpito_r1.webm";
import audio4m4a from "../../assets/sounds/S1_OMO_3_1_picara_r1.m4a";
import audio4webm from "../../assets/sounds/S1_OMO_3_1_picara_r1.webm";
import audio5m4a from "../../assets/sounds/S1_OMO_3_2_domine_r1.m4a";
import audio5webm from "../../assets/sounds/S1_OMO_3_2_domine_r1.webm";
import audio6m4a from "../../assets/sounds/S1_OMO_3_2_limite_r1.m4a";
import audio6webm from "../../assets/sounds/S1_OMO_3_2_limite_r1.webm";
import audio7m4a from "../../assets/sounds/S1_OMO_3_2_limite_r2.m4a";
import audio7webm from "../../assets/sounds/S1_OMO_3_2_limite_r2.webm";
import audio8m4a from "../../assets/sounds/S1_OMO_3_2_mascara_r1.m4a";
import audio8webm from "../../assets/sounds/S1_OMO_3_2_mascara_r1.webm";
import audio9m4a from "../../assets/sounds/S1_OMO_3_2_mascara_r2.m4a";
import audio9webm from "../../assets/sounds/S1_OMO_3_2_mascara_r2.webm";
import audio10m4a from "../../assets/sounds/S1_OMO_3_2_numero_r1.m4a";
import audio10webm from "../../assets/sounds/S1_OMO_3_2_numero_r1.webm";
import audio11m4a from "../../assets/sounds/S1_OMO_3_2_numero_r2.m4a";
import audio11webm from "../../assets/sounds/S1_OMO_3_2_numero_r2.webm";
import audio12m4a from "../../assets/sounds/S1_OMO_3_2_palpito_r1.m4a";
import audio12webm from "../../assets/sounds/S1_OMO_3_2_palpito_r1.webm";
import audio13m4a from "../../assets/sounds/S1_OMO_3_2_termino_r1.m4a";
import audio13webm from "../../assets/sounds/S1_OMO_3_2_termino_r1.webm";
import audio14m4a from "../../assets/sounds/S1_OMO_3_2_valido_r1.m4a";
import audio14webm from "../../assets/sounds/S1_OMO_3_2_valido_r1.webm";
import audio15m4a from "../../assets/sounds/S1_OMO_3_2_vinculo_r1.m4a";
import audio15webm from "../../assets/sounds/S1_OMO_3_2_vinculo_r1.webm";
import audio16m4a from "../../assets/sounds/S1_OMO_3_3_numero_r1.m4a";
import audio16webm from "../../assets/sounds/S1_OMO_3_3_numero_r1.webm";
import audio17m4a from "../../assets/sounds/S1_OMO_3_3_picara_r1.m4a";
import audio17webm from "../../assets/sounds/S1_OMO_3_3_picara_r1.webm";
import audio18m4a from "../../assets/sounds/S1_OMO_3_3_termino_r1.m4a";
import audio18webm from "../../assets/sounds/S1_OMO_3_3_termino_r1.webm";
import audio19m4a from "../../assets/sounds/S1_OMO_3_3_valido_r1.m4a";
import audio19webm from "../../assets/sounds/S1_OMO_3_3_valido_r1.webm";
import audio20m4a from "../../assets/sounds/S1_OMO_3_3_vinculo_r1.m4a";
import audio20webm from "../../assets/sounds/S1_OMO_3_3_vinculo_r1.webm";
import audio21m4a from "../../assets/sounds/S1_OMO_3_3_vinculo_r2.m4a";
import audio21webm from "../../assets/sounds/S1_OMO_3_3_vinculo_r2.webm";
import audio22m4a from "../../assets/sounds/S2_PRD_2_2_casa.m4a";
import audio22webm from "../../assets/sounds/S2_PRD_2_2_casa.webm";
import audio23m4a from "../../assets/sounds/S2_PRD_3_2_cocina.m4a";
import audio23webm from "../../assets/sounds/S2_PRD_3_2_cocina.webm";
import audio24m4a from "../../assets/sounds/S2_TRN_3_3_publico.m4a";
import audio24webm from "../../assets/sounds/S2_TRN_3_3_publico.webm";
import audio25m4a from "../../assets/sounds/S3_PRD_3_1_catedral.m4a";
import audio25webm from "../../assets/sounds/S3_PRD_3_1_catedral.webm";
import audio26m4a from "../../assets/sounds/S3_PRD_3_3_platano.m4a";
import audio26webm from "../../assets/sounds/S3_PRD_3_3_platano.webm";
import audio27m4a from "../../assets/sounds/S3_PRD_4_2_bicicleta.m4a";
import audio27webm from "../../assets/sounds/S3_PRD_4_2_bicicleta.webm";
import audio28m4a from "../../assets/sounds/S3_TRN_3_1_publico.m4a";
import audio28webm from "../../assets/sounds/S3_TRN_3_1_publico.webm";
import audio29m4a from "../../assets/sounds/S3_TRN_3_2_jubilo.m4a";
import audio29webm from "../../assets/sounds/S3_TRN_3_2_jubilo.webm";
import audio30m4a from "../../assets/sounds/S3_TRN_3_3_cantara.m4a";
import audio30webm from "../../assets/sounds/S3_TRN_3_3_cantara.webm";
import audio31m4a from "../../assets/sounds/S4_TRN_3_1_liquido.m4a";
import audio31webm from "../../assets/sounds/S4_TRN_3_1_liquido.webm";
import audio32m4a from "../../assets/sounds/S4_TRN_3_2_cubico.m4a";
import audio32webm from "../../assets/sounds/S4_TRN_3_2_cubico.webm";
import audio33m4a from "../../assets/sounds/S4_TRN_3_3_jubilo.m4a";
import audio33webm from "../../assets/sounds/S4_TRN_3_3_jubilo.webm";
import audio34m4a from "../../assets/sounds/S6_TRN_3_1_circulo.m4a";
import audio34webm from "../../assets/sounds/S6_TRN_3_1_circulo.webm";
import audio35m4a from "../../assets/sounds/S6_TRN_3_2_calculo.m4a";
import audio35webm from "../../assets/sounds/S6_TRN_3_2_calculo.webm";
import audio36m4a from "../../assets/sounds/S6_TRN_3_2_titulo.m4a";
import audio36webm from "../../assets/sounds/S6_TRN_3_2_titulo.webm";
import audio37m4a from "../../assets/sounds/S7_OMO_3_1_domine_r1.m4a";
import audio37webm from "../../assets/sounds/S7_OMO_3_1_domine_r1.webm";
import audio38m4a from "../../assets/sounds/S7_OMO_3_1_mascara_r1.m4a";
import audio38webm from "../../assets/sounds/S7_OMO_3_1_mascara_r1.webm";
import audio39m4a from "../../assets/sounds/S7_OMO_3_1_picara_r1.m4a";
import audio39webm from "../../assets/sounds/S7_OMO_3_1_picara_r1.webm";
import audio40m4a from "../../assets/sounds/S7_OMO_3_2_palpito_r1.m4a";
import audio40webm from "../../assets/sounds/S7_OMO_3_2_palpito_r1.webm";
import audio41m4a from "../../assets/sounds/S7_OMO_3_2_termino_r1.m4a";
import audio41webm from "../../assets/sounds/S7_OMO_3_2_termino_r1.webm";
import audio42m4a from "../../assets/sounds/S7_OMO_3_2_valido_r1.m4a";
import audio42webm from "../../assets/sounds/S7_OMO_3_2_valido_r1.webm";
import audio43m4a from "../../assets/sounds/SYSTEM_SUCCESS.m4a";
import audio43webm from "../../assets/sounds/SYSTEM_SUCCESS.webm";

export type BundledAudioSource = {
  url: string;
  type: string;
};

const AUDIO_ASSETS = {
  S1_OMO_3_1_domine_r1: [
    { url: audio0webm, type: 'audio/webm; codecs="opus"' },
    { url: audio0m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_1_limite_r1: [
    { url: audio1webm, type: 'audio/webm; codecs="opus"' },
    { url: audio1m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_1_mascara_r1: [
    { url: audio2webm, type: 'audio/webm; codecs="opus"' },
    { url: audio2m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_1_palpito_r1: [
    { url: audio3webm, type: 'audio/webm; codecs="opus"' },
    { url: audio3m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_1_picara_r1: [
    { url: audio4webm, type: 'audio/webm; codecs="opus"' },
    { url: audio4m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_2_domine_r1: [
    { url: audio5webm, type: 'audio/webm; codecs="opus"' },
    { url: audio5m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_2_limite_r1: [
    { url: audio6webm, type: 'audio/webm; codecs="opus"' },
    { url: audio6m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_2_limite_r2: [
    { url: audio7webm, type: 'audio/webm; codecs="opus"' },
    { url: audio7m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_2_mascara_r1: [
    { url: audio8webm, type: 'audio/webm; codecs="opus"' },
    { url: audio8m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_2_mascara_r2: [
    { url: audio9webm, type: 'audio/webm; codecs="opus"' },
    { url: audio9m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_2_numero_r1: [
    { url: audio10webm, type: 'audio/webm; codecs="opus"' },
    { url: audio10m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_2_numero_r2: [
    { url: audio11webm, type: 'audio/webm; codecs="opus"' },
    { url: audio11m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_2_palpito_r1: [
    { url: audio12webm, type: 'audio/webm; codecs="opus"' },
    { url: audio12m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_2_termino_r1: [
    { url: audio13webm, type: 'audio/webm; codecs="opus"' },
    { url: audio13m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_2_valido_r1: [
    { url: audio14webm, type: 'audio/webm; codecs="opus"' },
    { url: audio14m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_2_vinculo_r1: [
    { url: audio15webm, type: 'audio/webm; codecs="opus"' },
    { url: audio15m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_3_numero_r1: [
    { url: audio16webm, type: 'audio/webm; codecs="opus"' },
    { url: audio16m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_3_picara_r1: [
    { url: audio17webm, type: 'audio/webm; codecs="opus"' },
    { url: audio17m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_3_termino_r1: [
    { url: audio18webm, type: 'audio/webm; codecs="opus"' },
    { url: audio18m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_3_valido_r1: [
    { url: audio19webm, type: 'audio/webm; codecs="opus"' },
    { url: audio19m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_3_vinculo_r1: [
    { url: audio20webm, type: 'audio/webm; codecs="opus"' },
    { url: audio20m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S1_OMO_3_3_vinculo_r2: [
    { url: audio21webm, type: 'audio/webm; codecs="opus"' },
    { url: audio21m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S2_PRD_2_2_casa: [
    { url: audio22webm, type: 'audio/webm; codecs="opus"' },
    { url: audio22m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S2_PRD_3_2_cocina: [
    { url: audio23webm, type: 'audio/webm; codecs="opus"' },
    { url: audio23m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S2_TRN_3_3_publico: [
    { url: audio24webm, type: 'audio/webm; codecs="opus"' },
    { url: audio24m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S3_PRD_3_1_catedral: [
    { url: audio25webm, type: 'audio/webm; codecs="opus"' },
    { url: audio25m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S3_PRD_3_3_platano: [
    { url: audio26webm, type: 'audio/webm; codecs="opus"' },
    { url: audio26m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S3_PRD_4_2_bicicleta: [
    { url: audio27webm, type: 'audio/webm; codecs="opus"' },
    { url: audio27m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S3_TRN_3_1_publico: [
    { url: audio28webm, type: 'audio/webm; codecs="opus"' },
    { url: audio28m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S3_TRN_3_2_jubilo: [
    { url: audio29webm, type: 'audio/webm; codecs="opus"' },
    { url: audio29m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S3_TRN_3_3_cantara: [
    { url: audio30webm, type: 'audio/webm; codecs="opus"' },
    { url: audio30m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S4_TRN_3_1_liquido: [
    { url: audio31webm, type: 'audio/webm; codecs="opus"' },
    { url: audio31m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S4_TRN_3_2_cubico: [
    { url: audio32webm, type: 'audio/webm; codecs="opus"' },
    { url: audio32m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S4_TRN_3_3_jubilo: [
    { url: audio33webm, type: 'audio/webm; codecs="opus"' },
    { url: audio33m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S6_TRN_3_1_circulo: [
    { url: audio34webm, type: 'audio/webm; codecs="opus"' },
    { url: audio34m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S6_TRN_3_2_calculo: [
    { url: audio35webm, type: 'audio/webm; codecs="opus"' },
    { url: audio35m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S6_TRN_3_2_titulo: [
    { url: audio36webm, type: 'audio/webm; codecs="opus"' },
    { url: audio36m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S7_OMO_3_1_domine_r1: [
    { url: audio37webm, type: 'audio/webm; codecs="opus"' },
    { url: audio37m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S7_OMO_3_1_mascara_r1: [
    { url: audio38webm, type: 'audio/webm; codecs="opus"' },
    { url: audio38m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S7_OMO_3_1_picara_r1: [
    { url: audio39webm, type: 'audio/webm; codecs="opus"' },
    { url: audio39m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S7_OMO_3_2_palpito_r1: [
    { url: audio40webm, type: 'audio/webm; codecs="opus"' },
    { url: audio40m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S7_OMO_3_2_termino_r1: [
    { url: audio41webm, type: 'audio/webm; codecs="opus"' },
    { url: audio41m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  S7_OMO_3_2_valido_r1: [
    { url: audio42webm, type: 'audio/webm; codecs="opus"' },
    { url: audio42m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
  SYSTEM_SUCCESS: [
    { url: audio43webm, type: 'audio/webm; codecs="opus"' },
    { url: audio43m4a, type: 'audio/mp4; codecs="mp4a.40.2"' },
  ],
} as const satisfies Record<string, readonly BundledAudioSource[]>;

export type AudioAssetName = keyof typeof AUDIO_ASSETS;

export const getAudioAssetSources = (
  name: AudioAssetName,
): readonly BundledAudioSource[] => AUDIO_ASSETS[name];
